import { BrowserRouter } from "react-router-dom";
import HomeComponent from "./components/HomeComponent";

function App() {
  return (
    <div>
      <BrowserRouter>
        <HomeComponent />
      </BrowserRouter>
    </div>
  );
}

export default App;
